module.exports = __webpack_public_path__ + "img/101_titelbild3.cd8e6d10.jpg";